import { ActionReducerMap } from '@ngrx/store';
import { IAdditionalData, IAdditionalSettings, IBasicData, IConfigBasicData, IFile, IRegistrationData } from '@shared/model/basic-data';
import { basicDataReducer } from './basic-data.reducer';
import { additionalDataReducer } from './additional-data.reducer';
import { additionalSettingsReducer } from './additional-settings.reducer';
import { configReducer } from './config.reducer';
import { filesReducer } from './files.reducer';
import { registrationDataReducer } from './registration-data.reducer';

export interface IBasicDataState {
  additionalData: IAdditionalData | object;
  additionalSettings: IAdditionalSettings | object;
  basicData: IBasicData | object;
  config: IConfigBasicData | object;
  files: IFile[];
  registrationData: IRegistrationData | object;
}

export const basicDataReducers: ActionReducerMap<IBasicDataState> = {
  additionalData: additionalDataReducer,
  additionalSettings: additionalSettingsReducer,
  basicData: basicDataReducer,
  config: configReducer,
  files: filesReducer,
  registrationData: registrationDataReducer,
};
